import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import RecordsList from './components/RecordsList';
import PaymentsList from './components/PaymentsList';
import StatsPage from './components/StatsPage';
import RecordForm from './components/RecordForm';
import HospitalManagement from './components/HospitalManagement';
import UserManagement from './components/UserManagement';
import EmailProcessing from './components/EmailProcessing';
import WhatsAppMessages from './components/WhatsAppMessages';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <ProtectedRoute>
            <Navigation>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/records" element={<RecordsList />} />
                <Route path="/records/new" element={<RecordForm />} />
                <Route path="/records/edit/:id" element={<RecordForm />} />
                <Route path="/email-processing" element={<EmailProcessing />} />
                <Route path="/whatsapp" element={<WhatsAppMessages />} />
                <Route path="/payments" element={<PaymentsList />} />
                <Route path="/doctors" element={<StatsPage type="doctors" />} />
                <Route path="/hospitals" element={<StatsPage type="hospitals" />} />
                <Route path="/hospital-management" element={<HospitalManagement />} />
                <Route path="/user-management" element={<UserManagement />} />
              </Routes>
            </Navigation>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
